import {
  TaskPriority,
  TaskStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  IAvroSerialisedRawInlineNodes,
  IAvroSerialisedVersionedSchema,
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryInteraction,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  IBigQueryStatusHistory,
  ITimestampedDimension,
} from './common';

export interface ITaskDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    IBigQueryWorkflowItem,
    ITimestampedDimension {
  description?: IAvroSerialisedVersionedSchema;
  priority: TaskPriority;
  status: TaskStatus;
  statusHistory: IBigQueryStatusHistory<TaskStatus>[];
  /**
   * TaskType is an invalid avro enum
   */
  type: string;
  recurrenceConfiguration?: ISerialisedDocumentReference;
  assignedUser?: IBigQueryNamedDocument;
  assignedTeam?: IBigQueryNamedDocument;
  owner?: IBigQueryNamedDocument;
  visibleFrom: ISerialisedTimestamp;
}

export interface IBigQueryWorkflowItem {
  title: IAvroSerialisedRawInlineNodes;
  dueDate?: ISerialisedTimestamp;
  completedDate?: ISerialisedTimestamp;
  interactions: IBigQueryInteraction[];
}
